import { useEffect, useState } from 'react';

// docs/superpowers/specs/2026-05-28-s1-business-ux-cleanup-design.md §3.1
// — < 1280px 에서 CustomerDocumentsPanel 이 메인 그리드 하단으로 wrap.
// 인라인 CSSProperties 만 쓰는 코드베이스라 media query 를 JS-driven
// 으로 구현. SSR 호환을 위해 초기값은 false 로 두고, mount 이후 evaluate.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(query).matches;
  });
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    // older browsers expose `addListener`. Modern jsdom exposes neither sometimes.
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
    return undefined;
  }, [query]);
  return matches;
}
